var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{class:['material-icons', `md-${_vm.size}`, `rotate-${_vm.rotate}`, { 'rotation-animation': _vm.animationOn }]},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }